export enum ELengthName {
  MIN = 2,
  MAX = 30,
}
